export default "__VITE_ASSET__DCVFlY6X__"